export default "/images/breastfeeding_support_practices_sm.jpg?1193ae563afbfbf56cced6996e160ca0";